import React from 'react';
import { Card } from './ui/Card';
import { Monitor, TrendingUp, Check } from 'lucide-react';
export function UniqueValue() {
  return <section className="py-20 bg-[#0A0E27] relative overflow-hidden" data-id="element-300">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#141B3A]/50 to-transparent -z-10" data-id="element-301"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-303">
          <div data-id="element-304">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-305">
              IT + Vertrieb ={' '}
              <span className="text-[#FF5722]" data-id="element-306">Dein Vorteil</span>
            </h2>
            <p className="text-lg text-[#94A3B8] mb-8 leading-relaxed" data-id="element-307">
              Die meisten CRM-Berater sind entweder reine Techniker, die den
              Vertrieb nicht verstehen, oder Vertriebler ohne technisches
              Tiefenwissen. Ich vereine beides.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-308">
              <div className="flex items-start gap-4" data-id="element-309">
                <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0" data-id="element-310">
                  <Monitor className="w-6 h-6 text-blue-500" data-id="element-311" />
                </div>
                <div data-id="element-312">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-313">
                    IT & Entwicklung
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-314">
                    <li className="flex items-center gap-2" data-id="element-315">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-316" />
                      Programmierung (PHP, JS, Python)
                    </li>
                    <li className="flex items-center gap-2" data-id="element-317">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-318" />
                      Komplexe Webanwendungen
                    </li>
                    <li className="flex items-center gap-2" data-id="element-319">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-320" />
                      Professionelle IT-Architektur
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-321">
                <div className="w-12 h-12 rounded-lg bg-[#FF5722]/10 flex items-center justify-center flex-shrink-0" data-id="element-322">
                  <TrendingUp className="w-6 h-6 text-[#FF5722]" data-id="element-323" />
                </div>
                <div data-id="element-324">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-325">
                    Vertrieb & Praxis
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-326">
                    <li className="flex items-center gap-2" data-id="element-327">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-328" />3 Jahre aktive
                      Vertriebserfahrung
                    </li>
                    <li className="flex items-center gap-2" data-id="element-329">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-330" />
                      B2B und B2C Expertise
                    </li>
                    <li className="flex items-center gap-2" data-id="element-331">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-332" />
                      Eigenes Vertriebsteam aufgebaut
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-333">
            <Card className="p-8 border-[#334155] bg-[#141B3A]/80 backdrop-blur-sm" data-id="element-334">
              <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-335">
                Das Ergebnis
              </h3>
              <div className="space-y-4" data-id="element-336">
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-337">
                  <span className="text-[#94A3B8]" data-id="element-338">Technisch robust</span>
                  <span className="text-green-500 font-bold" data-id="element-339">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-340">
                  <span className="text-[#94A3B8]" data-id="element-341">Praktisch nutzbar</span>
                  <span className="text-green-500 font-bold" data-id="element-342">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-343">
                  <span className="text-[#94A3B8]" data-id="element-344">Akzeptanz im Team</span>
                  <span className="text-green-500 font-bold" data-id="element-345">Hoch</span>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-346">
                <p className="text-white font-medium mb-2" data-id="element-347">
                  "Keine Theorie – nur Praxis."
                </p>
                <p className="text-sm text-[#94A3B8]" data-id="element-348">
                  Jede Funktion wurde in der Praxis getestet und optimiert.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}